import {
  getStaffInfo,
  addComments,
  getScoreLabels,
  getFeedbackOrderList,
  getComplaintList,
  getComplaintInfo,
  dealComplaint,
  getFields,
  addComplaint,
  getCategoryList
} from '@/api/complaintEvaluate.js'

const state = {
}

const mutations = {
}

const actions = {
  // F-01-服务人员信息
  getStaffInfo(temp, data) {
    return new Promise((resolve, reject) => {
      getStaffInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // F-02-服务人员打分
  addComments(temp, data) {
    return new Promise((resolve, reject) => {
      addComments(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 服务人员打分选项
  getScoreLabels(temp, data) {
    return new Promise((resolve, reject) => {
      getScoreLabels(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // F-05-反馈订单列表
  getFeedbackOrderList(temp, data) {
    return new Promise((resolve, reject) => {
      getFeedbackOrderList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // F-06-反馈订单问题列表
  getComplaintList(temp, data) {
    return new Promise((resolve, reject) => {
      getComplaintList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // F-07-问题处理详情
  getComplaintInfo(temp, data) {
    return new Promise((resolve, reject) => {
      getComplaintInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // F-08-客诉处理
  dealComplaint(temp, data) {
    return new Promise((resolve, reject) => {
      dealComplaint(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 问题选项
  getFields(temp, data) {
    return new Promise((resolve, reject) => {
      getFields(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // F-04-客户问题反馈
  addComplaint(temp, data) {
    return new Promise((resolve, reject) => {
      addComplaint(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 问题分类列表
  getCategoryList(temp, data) {
    return new Promise((resolve, reject) => {
      getCategoryList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
